import config from 'config';
import { http_client } from './api';

const getList = async (jenjangID, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'jenjang/' +
        jenjangID +
        '/mapel?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (jenjangID, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'jenjang/' +
        jenjangID +
        '/mapel/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (jenjangID, data) => {
  return http_client.post(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/', data).then((response) => {
    return response.data;
  });
};
const read = async (jenjangID, id) => {
  return http_client.get(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + id).then((response) => {
    return response.data;
  });
};
const update = async (jenjangID, id, data) => {
  return http_client.patch(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (jenjangID, id) => {
  return await http_client.delete(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + id).then((response) => {
    return response.data;
  });
};
const changeStatus = async (jenjangID, id, data) => {
  return http_client.post(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/status/' + id, data).then((response) => {
    return response.data;
  });
};
const MapelService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default MapelService;
